import React from "react";
import { NavLink } from "react-router-dom";

function Login() {
  return (
    <>
      <div className="container ">
        <div className="row">
          <div className="col-lg-10 col-xl-9 mx-auto">
            <div className="card card-signin flex-row my-5">
              <div className="card-img-left d-none d-md-flex"></div>
              <div className="card-body">
                <h1 className="card-title text-center">Sign in </h1>
                <form className="form-signin">
                  <div className="form-label-group">
                    <input
                      type="email"
                      id="inputEmail"
                      className="form-control"
                      placeholder="Email address"
                      required
                    />
                    
                  </div>

                  <hr />

                  <div className="form-label-group">
                    <input
                      type="password"
                      id="inputPassword"
                      className="form-control"
                      placeholder="Password"
                      required
                    />
                
                  </div>

                  <button
                    className="btn btn-lg btn-success buttonss btn-block text-uppercase form-control"
                    type="submit"
                  >
                    Login
                  </button>

                  <NavLink
                    className="btn btn-lg btn-primary buttonss btn-block text-uppercase form-control"
                    to="/signup"
                  >
                    Sign Up
                  </NavLink>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
